export default __webpack_public_path__ + "static/media/pakrap-12.b98aba70.mp3";